"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadFont = void 0;
var load_font_1 = require("./load-font");
Object.defineProperty(exports, "loadFont", { enumerable: true, get: function () { return load_font_1.loadFont; } });
